import React from 'react';
import css from './ClubInfo.module.css';

import ellipses from './ellipse.png'

function ClubInfo() {
  return (
    <div className={css.clubInfoWrapper}>
      <div className={css.clubInfoEllipses}>
        <img src={ellipses} alt="" />
      </div>
      <div className={css.clubInfoContent}>
        <h4>With each club, you will receive up to 5 shipments of our limited-batch, barrel select wines to collect and savor. You will also enjoy exclusive member benefits as well as our trademark hospitality and VIP treatment at our winery.</h4>
        <ul className={css.clubInfoContentList}>
          <li>Free tasting for two today. Today’s paid tasting fee(s) refunded when you join a club and purchase three bottles.</li>
          <li>Free tasting for two today. Today’s paid tasting fee(s) refunded when you join a club and purchase three bottles.</li>
          <li>Free tasting for two today. Today’s paid tasting fee(s) refunded when you join a club and purchase three bottles.</li>
          <li>Free tasting for two today. Today’s paid tasting fee(s) refunded when you join a club and purchase three bottles.</li>
          <li>Free tasting for two today. Today’s paid tasting fee(s) refunded when you join a club and purchase three bottles.</li>
          <li>Free tasting for two today. Today’s paid tasting fee(s) refunded when you join a club and purchase three bottles.</li>
          <li>Free tasting for two today. Today’s paid tasting fee(s) refunded when you join a club and purchase three bottles.</li>
          <li>Free tasting for two today. Today’s paid tasting fee(s) refunded when you join a club and purchase three bottles.</li>
        </ul>
      </div>
    </div>
  )
}

export default ClubInfo
